// src/pages/Unauthorized.js
import React from 'react';
import { 
  Container, 
  Typography, 
  Button, 
  Box,
  Paper
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import SecurityIcon from '@material-ui/icons/Security';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    padding: theme.spacing(3),
  },
  paper: {
    padding: theme.spacing(4),
    textAlign: 'center',
    maxWidth: 500,
    width: '100%',
  },
  icon: {
    fontSize: 80,
    color: theme.palette.warning.main,
    marginBottom: theme.spacing(2),
  },
  title: {
    marginBottom: theme.spacing(2),
    color: theme.palette.warning.dark,
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

const Unauthorized = () => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <SecurityIcon className={classes.icon} />
        <Typography variant="h4" className={classes.title} gutterBottom>
          Accès refusé
        </Typography>
        <Typography variant="h6" gutterBottom>
          Autorisation insuffisante
        </Typography>
        <Typography variant="body1" color="textSecondary" paragraph>
          Vous n'avez pas les permissions nécessaires pour accéder à cette page.
          Veuillez contacter votre administrateur si vous pensez qu'il s'agit d'une erreur.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          component={Link}
          to="/dashboard"
          startIcon={<ArrowBackIcon />}
          className={classes.button}
        >
          Retour au tableau de bord
        </Button>
      </Paper>
    </Container>
  );
};

export default Unauthorized;